import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function ChilledDessertsPage() {

    const heroData = [
        {
          title: "Chilled Desserts",
          content: "Cool off with our chilled desserts, a collection of creamy mousses, fruity parfaits, and refreshing puddings. Perfectly balanced to satisfy your sweet tooth and refresh your palate.",
          image: images.ChilledDessertHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Classic Tiramisu",
        image: [
          images.ChilledDessert1,
        ]
      },
      {
        name: "Matcha Tiramisu",
        image: [
          images.ChilledDessert2,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Classic Tiramisu",
        image1: [
          images.ChilledDessert1,
        ],
        content1: "",
        name2: "Matcha Tiramisu",
        image2: [
          images.ChilledDessert2,
        ],
        content2: ""
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
